const AudienceIndex = () => import('@/modules/audiences/views/AudienceIndex')

export default [
  {
    path: '/audiences',
    name: 'audiences.index',
    component: AudienceIndex
  }
]
